import { MaintenanceWindowPatchManagementVendorProductSelectorWebComponent } from './component/MaintenanceWindowPatchManagementVendorProductSelectorWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_PATCH_MANAGEMENT_VENDOR_PRODUCT_SELECTOR } from '../../webcomponents.constants';

export { MaintenanceWindowPatchManagementVendorProductSelectorWebComponent };

window.customElements.define(
  WEB_COMPONENT_MAINTENANCE_WINDOW_PATCH_MANAGEMENT_VENDOR_PRODUCT_SELECTOR,
  MaintenanceWindowPatchManagementVendorProductSelectorWebComponent
);
